const RICOS_VERSION = "10.149.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
